import { Typography } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { useGetProfilePicture } from '~/entities/Employee/hooks/useGetProfilePicture';

import { AvatarWithInitials } from '../AvatarWithInitials';

interface CreatedByBadgeProps {
  name: string;
  globalId?: string;
}

export function CreatedByBadge({
  name,
  globalId
}: Readonly<CreatedByBadgeProps>) {
  const { t } = useTranslate();
  const { imageSrc } = useGetProfilePicture(globalId || '');

  if (!name.trim()) {
    return null;
  }

  return (
    <div className="flex items-center gap-3">
      <AvatarWithInitials name={name} src={imageSrc || undefined} size="md" />
      <div className="flex flex-col gap-0.5">
        <Typography variant="metadata-sm-regular" color="light">
          {t('common.createdBy', 'Created by')}
        </Typography>
        <Typography variant="metadata-sm-bold" color="default">
          {name}
        </Typography>
      </div>
    </div>
  );
}
